import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
export var Content = styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-1tdpmi8-0"
})(["display:flex;flex-direction:column;justify-content:space-between;min-height:60px;padding:0;margin-top:8px;"]);
export var ListRowContent = styled.div.withConfig({
  displayName: "Content__ListRowContent",
  componentId: "sc-1tdpmi8-1"
})(["display:flex;width:100%;margin:10px 0;"]);
export var VideoMetaContent = styled.div.withConfig({
  displayName: "Content__VideoMetaContent",
  componentId: "sc-1tdpmi8-2"
})(["display:flex;flex-direction:column-reverse;width:calc(100% - 180px);padding:20px;", ";span{padding:5px 0;color:", ";text-align:left;", ";}"], minMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-direction: row;\n    align-items: center;\n    padding: 0;\n  "]))), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciary;
}, minMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      min-width: 140px;\n      padding: 0 20px;\n      text-align: center;\n    "]))));
export var NewHighlight = styled.span.withConfig({
  displayName: "Content__NewHighlight",
  componentId: "sc-1tdpmi8-3"
})(["background-color:", ";color:", ";", ";padding:3px 6px;border-radius:15px;position:absolute;right:-8px;top:-10px;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.terciaryLL;
}, getFont(-2, 'compact'));